
import { Component, Prop, Vue } from 'vue-property-decorator';
import type { ReviewInventorySignals } from '@/utils/purchase-order/inventoryReportRowMapper';
import { reviewChips, type ReviewChipSpec } from '@/utils/purchase-order/reviewChips';

@Component
export default class ReviewInventoryChips extends Vue {
  @Prop({ default: null }) public readonly inv!: ReviewInventorySignals | null;
  @Prop({ default: false }) public readonly loading!: boolean;

  public get chips(): ReviewChipSpec[] {
    return reviewChips(this.inv);
  }
}
